import React, { useState, useEffect, useRef } from 'react';

const GallerySection = () => {

    const [activeGraduateSlide, setActiveGraduateSlide] = useState(0);
    const [activeClassSlide, setActiveClassSlide] = useState(0);


    const graduateImages = [
        {
            id: 1,
            image: require('../assets/imagenes/egresadas/egresadas1.png'),
        },
        {
            id: 2,
            image: require('../assets/imagenes/egresadas/egresadas2.png'),
        },
        {
            id: 3,
            image: require('../assets/imagenes/egresadas/egresadas3.png'),
        },
        {
            id: 4,
            image: require('../assets/imagenes/egresadas/egresadas4.png'),
        },
        {
            id: 5,
            image: require('../assets/imagenes/egresadas/egresadas5.png'),
        }
    ];

    const classImages = [
        {
            id: 1,
            image: require('../assets/imagenes/clases/clases1.png'),
        },
        {
            id: 2,
            image: require('../assets/imagenes/clases/clases2.png'),
        },
        {
            id: 3,
            image: require('../assets/imagenes/clases/clases3.png'),
        },
        {
            id: 4,
            image: require('../assets/imagenes/clases/clases4.png'),
        },
        {
            id: 5,
            image: require('../assets/imagenes/clases/clases5.png'),
        }
    ];

    // Auto-rotate carousels
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveGraduateSlide((prev) => (prev + 1) % graduateImages.length);
        }, 4000);

        return () => clearInterval(interval);
    }, [graduateImages.length]);

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveClassSlide((prev) => (prev + 1) % classImages.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [classImages.length]);

    const nextGraduateSlide = () => {
        setActiveGraduateSlide((prev) => (prev + 1) % graduateImages.length);
    };

    const prevGraduateSlide = () => {
        setActiveGraduateSlide((prev) => (prev - 1 + graduateImages.length) % graduateImages.length);
    };

    const nextClassSlide = () => {
        setActiveClassSlide((prev) => (prev + 1) % classImages.length);
    };

    const prevClassSlide = () => {
        setActiveClassSlide((prev) => (prev - 1 + classImages.length) % classImages.length);
    };

    return (
        <section className="py-20 bg-black relative overflow-hidden">
            {/* Simple Background Pattern */}
            <div className="absolute inset-0">
                <div className="absolute inset-0 bg-black"></div>
                <div className="absolute bottom-0 left-0 w-full h-2/3 bg-gradient-to-tr from-amber-900/20 to-transparent rounded-full blur-3xl"></div>
                <div className="absolute top-1/4 right-0 w-3/5 h-2/5 bg-gradient-to-bl from-amber-800/25 to-transparent rounded-full blur-2xl"></div>
            </div>

            <div className="max-w-7xl mx-auto px-6 relative z-10">
                {/* Header */}
                <div className={`text-center mb-16 transition-all duration-1000`}>
                    <span className="inline-block bg-primary text-white px-6 py-2 rounded-full text-sm font-medium mb-6">
                        Nuestra Comunidad
                    </span>
                    <h2 className="text-4xl lg:text-5xl font-light text-white mb-4">
                        Historias de <span className="text-primary">Éxito</span>
                    </h2>
                    <p className="text-lg text-gray-300 max-w-3xl mx-auto">
                        Celebramos los logros de nuestras graduadas y el crecimiento de nuestras estudiantes
                    </p>
                </div>

                <div className="grid lg:grid-cols-2 gap-12">
                    {/* Graduates Carousel */}
                    <div className={`transition-all duration-1000 delay-200`}>
                        <div className="mb-8">
                            <h3 className="text-2xl font-light text-white mb-2">
                                Nuestras <span className="text-primary">Graduadas</span>
                            </h3>
                            <p className="text-gray-300">
                                Profesionales exitosas que han transformado sus vidas
                            </p>
                        </div>

                        <div className="relative group">
                            <div className="relative h-80 md:h-96 rounded-2xl overflow-hidden bg-zinc-900/80 border border-zinc-700/50">
                                {graduateImages[activeGraduateSlide].image ? (
                                    <img
                                        src={graduateImages[activeGraduateSlide].image}
                                        alt={`Graduada ${activeGraduateSlide + 1} - Profesional exitosa de la Escuela Verónica Dandrea`}
                                        className="w-full h-full object-contain"
                                    />
                                ) : (
                                    <div className="w-full h-full bg-zinc-800 flex items-center justify-center">
                                        <div className="w-20 h-20 bg-primary rounded-2xl flex items-center justify-center">
                                            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                            </svg>
                                        </div>
                                    </div>
                                )}
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent pointer-events-none"></div>

                                {/* Navigation Buttons */}
                                <button
                                    onClick={prevGraduateSlide}
                                    className="absolute left-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-black/60 hover:bg-primary/80 rounded-full flex items-center justify-center transition-all duration-300 opacity-0 group-hover:opacity-100 border border-zinc-600"
                                >
                                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                    </svg>
                                </button>

                                <button
                                    onClick={nextGraduateSlide}
                                    className="absolute right-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-black/60 hover:bg-primary/80 rounded-full flex items-center justify-center transition-all duration-300 opacity-0 group-hover:opacity-100 border border-zinc-600"
                                >
                                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>
                            </div>

                            {/* Dots Indicator */}
                            <div className="flex justify-center space-x-3 mt-6">
                                {graduateImages.map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => setActiveGraduateSlide(index)}
                                        className={`w-3 h-3 rounded-full transition-all duration-300 ${index === activeGraduateSlide
                                            ? 'bg-primary scale-125'
                                            : 'bg-zinc-600 hover:bg-zinc-500'
                                            }`}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Class Carousel */}
                    <div className={`transition-all duration-1000 delay-400`}>
                        <div className="mb-8">
                            <h3 className="text-2xl font-light text-white mb-2">
                                En <span className="text-secondary">Formación</span>
                            </h3>
                            <p className="text-gray-300">
                                Estudiantes desarrollando sus habilidades profesionales
                            </p>
                        </div>

                        <div className="relative group">
                            <div className="relative h-80 md:h-96 rounded-2xl overflow-hidden bg-zinc-900/80 border border-zinc-700/50">
                                {classImages[activeClassSlide].image ? (
                                    <img
                                        src={classImages[activeClassSlide].image}
                                        alt={`Estudiantes en formación ${activeClassSlide + 1} - Escuela Verónica Dandrea`}
                                        className="w-full h-full object-contain"
                                    />
                                ) : (
                                    <div className="w-full h-full bg-zinc-800 flex items-center justify-center">
                                        <div className="w-20 h-20 bg-secondary rounded-2xl flex items-center justify-center">
                                            <svg className="w-10 h-10 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                                            </svg>
                                        </div>
                                    </div>
                                )}
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent pointer-events-none"></div>

                                {/* Navigation Buttons */}
                                <button
                                    onClick={prevClassSlide}
                                    className="absolute left-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-black/60 hover:bg-secondary/80 rounded-full flex items-center justify-center transition-all duration-300 opacity-0 group-hover:opacity-100 border border-zinc-600"
                                >
                                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                    </svg>
                                </button>

                                <button
                                    onClick={nextClassSlide}
                                    className="absolute right-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-black/60 hover:bg-secondary/80 rounded-full flex items-center justify-center transition-all duration-300 opacity-0 group-hover:opacity-100 border border-zinc-600"
                                >
                                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>
                            </div>

                            {/* Dots Indicator */}
                            <div className="flex justify-center space-x-3 mt-6">
                                {classImages.map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => setActiveClassSlide(index)}
                                        className={`w-3 h-3 rounded-full transition-all duration-300 ${index === activeClassSlide
                                            ? 'bg-secondary scale-125'
                                            : 'bg-zinc-600 hover:bg-zinc-500'
                                            }`}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GallerySection; 